export const LAYOUT_0_24 = {
  labelCol: {
    span: 0,
  },
  wrapperCol: {
    span: 24,
  },
};

export const VALIDATE_MESSAGES = {
  required: "'${label}' is required",
};
